export default __webpack_public_path__ + "static/media/logo_menu.d5712862.png";